// extracted by mini-css-extract-plugin
export var avatar = "_n5-3";
export var avatarContainer = "_n5-2";
export var avatarSpacer = "_n5-5";
export var avatarSpacerContainer = "_n5-4";
export var avatarStackContainer = "_n5-1";
export var bubble = "_n5-0";
export var remainderBubble = "_n5-6";